import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { API_BASE } from "@/lib/api";

export default function PageHeader({ title, subtitle, action, exportEntity, testid, eyebrow = "Module" }) {
  const onExport = () => {
    const token = localStorage.getItem("token");
    const url = `${API_BASE}/export/${exportEntity}`;
    fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {}, credentials: "include" })
      .then((r) => r.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${exportEntity}.csv`;
        link.click();
      });
  };

  return (
    <div
      className="flex flex-wrap items-end justify-between gap-4 mb-8 pb-6 border-b border-[#3A4640]"
      data-testid={testid}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="tzat-pulse" />
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#39FF14] font-heading font-semibold">{eyebrow}</div>
        </div>
        <h1 className="font-heading text-3xl lg:text-[32px] font-bold text-[#F8F9FA] tracking-tight">{title}</h1>
        {subtitle && (
          <p className="text-[#8A8F98] mt-1.5 text-sm max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {exportEntity && (
          <Button
            variant="outline"
            onClick={onExport}
            data-testid={`export-${exportEntity}-btn`}
            className="bg-transparent border border-[#3A4640] text-[#8A8F98] hover:text-[#F8F9FA] hover:border-[#39FF14]/40 rounded-[10px]"
          >
            <Download size={14} className="mr-2" /> Export CSV
          </Button>
        )}
        {action}
      </div>
    </div>
  );
}
